import {
  IUpsertAnnouncementCommand,
  UpsertAnnouncementCommand,
} from "@growth-machine-llc/stridist-api-client";
import { announcementsClient } from "../api/ApiClients";
import ServiceBase from "./ServiceBase";

class AnnouncementsService extends ServiceBase {
  async getCurrentAnnouncement() {
    return announcementsClient.getCurrentAnnouncement();
  }

  async upsertAnnouncement(variables: IUpsertAnnouncementCommand) {
    const command = UpsertAnnouncementCommand.fromJS(variables);
    return announcementsClient.upsertAnnouncement(command);
  }
}

export default new AnnouncementsService();
